
module dgLogger {
    angular.module('dgLogger')
        .config(($httpProvider: ng.IHttpProvider) => {
            $httpProvider.interceptors.push('dgHttpLoggerInterceptor');
        });
}